import React from 'react'
import { Row, Col, FormGroup, FormControl, ControlLabel } from 'react-bootstrap'
import i18next from 'i18next'
import { Link } from 'react-router'

import Button from './Button'

export default class UnitForm extends React.Component {
  constructor(props) {
    super(props)

    const { unit } = this.props

    this.state = {
      name: unit ? unit.name : '',
      description: unit ? unit.description : '',
      isValid: !!unit
    }
  }

  handleChange = e => {
    this.setState(
      {
        [e.target.name]: e.target.value
      },
      this.validate
    )
  }

  validate = () => {
    this.setState(state => ({ isValid: state.name.trim() !== '' }))
  }

  handleAdd = () => {
    this.props.onSubmit({ name: this.state.name, description: this.state.description })
  }

  render() {
    return (
      <div>
        <Row>
          <Col md={12}>
            <Row>
              <Col md={12}>
                <FormGroup controlId="name">
                  <ControlLabel>{i18next.t('unit_name')}</ControlLabel>
                  <FormControl
                    name="name"
                    type="text"
                    onChange={this.handleChange}
                    value={this.state.name}
                  />
                </FormGroup>

                <FormGroup controlId="description">
                  <ControlLabel>{i18next.t('unit_description')}</ControlLabel>
                  <FormControl
                    name="description"
                    type="text"
                    onChange={this.handleChange}
                    value={this.state.description}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Col>
        </Row>

        <div>
          <Button
            text={i18next.t('save')}
            onClick={this.handleAdd}
            disabled={!this.state.isValid}
          />

          <span style={{ marginLeft: 5 }}>
            {i18next.t('or')} <Link to="/units">{i18next.t('cancel')}</Link>
          </span>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UnitForm.js